/** @jsx h */
import { h, app } from "hyperapp";
import bus from "../bus";

export const historyProgressEvents = {
  ACTIVATE: "HISTORY_PROGRESS:ACTIVATE",
  DEACTIVATE: "HISTORY_PROGRESS:DEACTIVATE"
};

function view(state, actions) {
  const width = `${state.value * 100}%`;
  const opacity = state.visible ? 0.9 : 0;
  return (
    <div
      class="history-progress__bar"
      oncreate={actions.onCreate}
      ondestroy={actions.onDestroy}
      style={{ width, opacity }}
    />
  );
}

export default function historyProgress(el, props) {
  if (el.getAttribute("initialised") === "true") {
    return;
  }
  el.setAttribute("initialised", "true");
  const initialState = {
    destroyed: false,
    visible: false,
    timer: null,
    value: 0
  };
  const initialActions = {
    destroy: () => ({ destroy: true }),
    set: partialState => partialState,
    tick: () => ({ value }) => {
      value = value + Math.random() / 50;
      return {
        value
      };
    },
    activate: () => ({ timer }, { tick }) => {
      clearInterval(timer);
      timer = setInterval(tick, 200);
      return {
        timer,
        visible: true,
        value: 0.1
      };
    },
    deactivate: () => ({ timer }) => {
      clearInterval(timer);
      return {
        visible: false,
        value: 0
      };
    },
    onCreate: () => (state, actions) => {
      bus.on(historyProgressEvents.ACTIVATE, actions.activate);
      bus.on(historyProgressEvents.DEACTIVATE, actions.deactivate);
    },
    onDestroy: () => {}
  };
  let instance = app(initialState, initialActions, view, el);
  return {
    destroy: () => {
      instance.destroy();
      instance = null;
    }
  };
}
